const ENV_MODE = 0;
const Configs = {
    API: {
        BASE : ENV_MODE ? 'http://localhost:80/' : 'https://api.treidblue.com/'
    },
}
export default Configs;